define('specific/instagram/models/InstagramModel', [

], function() {

    var Instagram = Backbone.Model.extend({
        defaults: {
            "type": "instagram",
            "viewId": "instagram",
            "isReady": false
        }
    });

    return Instagram;
});
